import React, { Suspense } from 'react';
import MainSkeleton from '../components/MainSkeleton';
import { MainPage } from '../components/mainPage/MainPage';

function MainRoute() {
    return (
        <Suspense fallback={<MainSkeleton />}>
            <MainPage />
        </Suspense>
    );
}

export default React.memo(MainRoute);
